module.exports = __webpack_public_path__ + "img/qepcopy.cb675d67.png";